import { aiDashboardAssets } from '../configs/constants';

const aiDashboardAppsSelector = (state) => state.aiDashboard[aiDashboardAssets.apps];
const aiMarketOverviewSelector = (state) => state.aiDashboard[aiDashboardAssets.marketOverview];
const timeSpentPenetrationSelector = (state) =>
  state.aiDashboard[aiDashboardAssets.timeSpentPenetration];
const timeSpentPenetrationIndexSelector = (state) =>
  state.aiDashboard[aiDashboardAssets.timeSpentPenetrationIndex];
const usageTrendsSelector = (state) => state.aiDashboard[aiDashboardAssets.usageTrends];
const usageTransitionsSelector = (state) => state.aiDashboard[aiDashboardAssets.usageTransitions];
const sectorsStatsSelector = (state) => state.aiDashboard[aiDashboardAssets.sectorsStats];
const segmentConcentrationSelector = (state) =>
  state.aiDashboard[aiDashboardAssets.segmentConcentration];
const aiAppTrendsSelector = (state) => state.aiDashboard[aiDashboardAssets.aiAppTrends];
const segmentTransitionsSelector = (state) =>
  state.aiDashboard[aiDashboardAssets.segmentTransitions];
const aiAppImpactSelector = (state) => state.aiDashboard[aiDashboardAssets.aiAppImpact];
const financeAppsSelector = (state) => state.aiDashboard[aiDashboardAssets.financeApps];

export {
  aiDashboardAppsSelector,
  aiMarketOverviewSelector,
  timeSpentPenetrationSelector,
  timeSpentPenetrationIndexSelector,
  usageTrendsSelector,
  usageTransitionsSelector,
  sectorsStatsSelector,
  segmentConcentrationSelector,
  aiAppTrendsSelector,
  segmentTransitionsSelector,
  aiAppImpactSelector,
  financeAppsSelector,
};
